import { Button, Checkbox, Col, Input, message, Popconfirm, Row } from "antd";
import { UsergroupAddOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";

export default function CreateAcctsProfilesFunction(props) {
  const [messageApi, contextHolder] = message.useMessage();

  const [quantity, setQuantity] = useState('5');
  const [tabs, setTabs] = useState('5');
  const [sleepStep, setSleepStep] = useState('3');
  const [sleepAcct, setSleepAcct] = useState('3');
  const [verifyDUNS, setVerifyDUNS] = useState(true);
  const [useOffer, setUseOffer] = useState(true);

  // sheet profiles
  const [tabsNum, setTabsNum] = useState('5');
  const [sheetURL_p, setSheetURL_p] = useState('');
  const [sheetName_p, setSheetName_p] = useState('Trang Tính1');

  // sheet visa
  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('Trang Tính1');

  const [verifyPayment, setVerifyPayment] = useState(true);
  const [manual, setManual] = useState(true);

  const createAccts = async () => {
    if(!sheetURL || !sheetName) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    
    messageApi.info(`>>> Tạo TK full...`);
    let body = {
      tabsNum,
      sheetProfiles: {
        sheetId: sheetURL_p.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName_p,
      },
      sheetVisa: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      },
      quantity,
      tabs,
      verifyDUNS,
      useOffer,
      sleepStep: +sleepStep*1000,
      sleepAcct: +sleepAcct*1000,
      verifyPayment,
      manual
    };
    axios
      .post(`${API_HOST}/api/create-accts-profiles`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Create Accts Profiles ~ error:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetName_p = localStorage.getItem('create-accts-profile-sheetName_p')
    if(sheetName_p) {
      setSheetName_p(sheetName_p)
    }
    let sheetURL_p = localStorage.getItem('create-accts-profile-sheetURL_p')
    if(sheetURL_p) {
      setSheetURL_p(sheetURL_p)
    }
    let tabsNum = localStorage.getItem('create-accts-profile-tabsNum')
    if(tabsNum) {
      setTabsNum(tabsNum)
    }
    let sheetName = localStorage.getItem('tkcn-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('tkcn-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
    let verifyDUNS = localStorage.getItem('tkcn-duns')
    if(verifyDUNS) {
      setVerifyDUNS(verifyDUNS === 'true')
    }
    let useOffer = localStorage.getItem('tkcn-useOffer')
    if(useOffer) {
      setUseOffer(useOffer === 'true')
    }
    let sleepStep = localStorage.getItem('tkcn-sleepStep')
    if(sleepStep) {
      setSleepStep(sleepStep)
    }
    let sleepAcct = localStorage.getItem('tkcn-sleepAcct')
    if(sleepAcct) {
      setSleepAcct(sleepAcct)
    }
    let tabs = localStorage.getItem('tkcn-tabs')
    if(tabs) {
      setTabs(tabs)
    }
    let quantity = localStorage.getItem('tkcn-quantity')
    if(quantity) {
      setQuantity(quantity)
    }

    let verifyPayment = localStorage.getItem('tkcn-verifyPayment')
    if(verifyPayment) {
      setVerifyPayment(verifyPayment === 'true')
    }
    let manual = localStorage.getItem('tkcn-manual')
    if(manual) {
      setManual(manual === 'true')
    }

  }, [])

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '600px' }}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Create Accts Profiles"
        description={
          <div style={{ width: '600px' }}>
            <b>GG sheet PROFILE: </b>
            <Row>
              <Col span={4}>
                <label>SL Chrome: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={tabsNum}
                  style={{ width: 100 }}
                  placeholder="Số Lượng Chrome..."
                  onChange={(e) => {
                    setTabsNum(e.target.value);
                    localStorage.setItem('create-accts-profile-tabsNum', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={20}>
               <Input
                  value={sheetURL_p}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL_p(e.target.value);
                    localStorage.setItem('create-accts-profile-sheetURL_p', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={20}>
                 <Input
                    value={sheetName_p}
                    style={{ width: 200 }}
                    placeholder="CREATE ACCTS EMAIL"
                    onChange={(e) => {
                      setSheetName_p(e.target.value);
                      localStorage.setItem('create-accts-profile-sheetName_p', e.target.value);
                    }}
                  />
              </Col>
            </Row>
            
            <br></br>
            <b>GG sheet VISA: </b>
            <Row>
              <Col span={4}>
                <label>URL: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={sheetURL}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL(e.target.value);
                    localStorage.setItem('tkcn-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={4}>
                <label>Trang: </label>
              </Col>
              <Col span={20}>
                  <Input
                    value={sheetName}
                    style={{ width: 200 }}
                    placeholder="SheetName ..."
                    onChange={(e) => {
                      setSheetName(e.target.value);
                      localStorage.setItem('tkcn-sheetName', e.target.value);
                    }}
                  />
              </Col>
            </Row>

            <Row>
                <Col span={10}>
                  <label>Số Lượng: </label>
                </Col>
                <Col span={14}>
                  <Input
                    value={quantity}
                    type="number"
                    style={{ width: 60 }}
                    placeholder="Số Lượng ..."
                    onChange={(e) => {
                      setQuantity(e.target.value)
                      localStorage.setItem("tkcn-quantity", e.target.value);
                    }}
                  />
                </Col>
                <Col span={10}>
                  <label>Số Tab: </label>
                </Col>
                <Col span={14}>
                  <Input
                    value={tabs}
                    type="number"
                    style={{ width: 60 }}
                    placeholder="Số Lượng Tab ..."
                    onChange={(e) => {
                      setTabs(e.target.value);
                      localStorage.setItem("tkcn-tabs", e.target.value);
                    }}
                  />
                </Col>
          
                <Col span={10}>
                    <label>Nghỉ Sau Mỗi Bước: (giây)</label>
                </Col>
                <Col span={14}>
                    <Input
                      value={sleepStep}
                      style={{ width: 60 }}
                      placeholder="Giây ..."
                      onChange={(e) => {
                        setSleepStep(e.target.value)
                        localStorage.setItem("tkcn-sleepStep", e.target.value);
                      }}
                    />
                </Col>
                <Col span={10}>
                    <label>Nghỉ Sau Mỗi TK: (giây)</label>
                </Col>
                <Col span={14}>
                    <Input
                      value={sleepAcct}
                      style={{ width: 60 }}
                      placeholder="Số Giây ..."
                      onChange={(e) => {
                        setSleepAcct(e.target.value)
                        localStorage.setItem("tkcn-sleepAcct", e.target.value);
                      }}
                    />
                </Col>
                <Col span={10}>
                    <label>Xác Minh D.U.N.S</label>
                </Col>
                <Col span={14}>
                    <Checkbox checked={verifyDUNS} onChange={e => {
                      setVerifyDUNS(e.target.checked)
                      localStorage.setItem("tkcn-duns", e.target.checked+'');
                    }}>
                    </Checkbox>
                </Col>
                <Col span={10}>
                    <label>Tạo từ Offer</label>
                </Col>
                <Col span={14}>
                    <Checkbox checked={useOffer} onChange={e => {
                      setUseOffer(e.target.checked)
                      localStorage.setItem("tkcn-useOffer", e.target.checked+'');
                    }}>
                    </Checkbox>
                </Col>

                  <Col span={10}>
                      <label>Xác Minh VISA</label>
                  </Col>
                  <Col span={14}>
                      <Checkbox checked={verifyPayment} onChange={e => {
                          setVerifyPayment(e.target.checked)
                          localStorage.setItem("tkcn-verifyPayment", `${e.target.checked}`);
                        }}>
                      </Checkbox>
                  </Col>
                  <Col span={10}>
                      <label>Lấy CODE Thủ Công</label>
                  </Col>
                  <Col span={14}>
                    <Checkbox checked={manual} onChange={e => {
                        setManual(e.target.checked);
                        localStorage.setItem("tkcn-manual", `${e.target.checked}`);
                      }}>
                    </Checkbox>
                  </Col>
            </Row>
            

          </div>
        }
        onConfirm={() => createAccts()}
      >
        <Button danger><UsergroupAddOutlined />Tạo TK FULL</Button>
      </Popconfirm>
    </>
  );
}